import { addNamespaceInOperations } from '../helper'
import { v4 as uuidv4 } from 'uuid'
import Vue from 'vue'

export const MUTATIONS_METHODS = {
  CREATE_VIEW: 'createView',
  DELETE_VIEW: 'deleteView',
  CHANGE_VIEW_NAME: 'chageViewName',
  CLONE_VIEW: 'cloneView',
  ADD_OBJECT: 'addObject',
  UPDATE_OBJECT: 'updateObject',
  MOVE_OBJECT: 'moveObject',
  DELETE_OBJECT: 'deleteObject',
  SET_JAVASCRIPT: 'setJavascript',
  SET_STYLE: 'setStyle',
  SET_CONNECTIONS: 'setConnections',
  CREATE_AVAILABLE_COMPONENTS: 'createAvailableComponents',
  DELETE_AVAILABLE_COMPONENTS: 'deleteAvailableComponents'
}

export const mutations = {
  [MUTATIONS_METHODS.CREATE_AVAILABLE_COMPONENTS] (state, { id = '', name, image }) {
    id = id.toLowerCase()
    if (id.startsWith('http') && !state.availableComponents.find(e => e.id === id)) {
      state.availableComponents.push({ id, name, image })
    }
  },
  [MUTATIONS_METHODS.DELETE_AVAILABLE_COMPONENTS] (state, { id = '' }) {
    id = id.toLowerCase()
    if (id.startsWith('http')) {
      Vue.set(state, 'availableComponents', state.availableComponents.filter(e => e.id !== id))
    }
  },
  [MUTATIONS_METHODS.SET_CONNECTIONS] (state, { connections = [] }) {
    Vue.set(state, 'connections', connections)
  },
  [MUTATIONS_METHODS.SET_STYLE] (state, { code = '' }) {
    Vue.set(state, 'style', code)
  },
  [MUTATIONS_METHODS.SET_JAVASCRIPT] (state, { code = '' }) {
    Vue.set(state, 'javascript', code)
  },
  [MUTATIONS_METHODS.DELETE_VIEW] (state, { view = '' }) {
    const viewName = view.replace(/[^\w]/gi, '')
    if (state.views[viewName]) {
      Vue.delete(state.views, viewName)
    }
  },
  [MUTATIONS_METHODS.CREATE_VIEW] (state, { view = '', metaInfo = {}, viewClass = {}, components = [] }) {
    const viewName = view.replace(/[^\w]/gi, '')
    if (!state.views[viewName]) {
      Vue.set(state.views, viewName, {
        metaInfo,
        viewClass,
        components
      })
    }
  },
  [MUTATIONS_METHODS.CHANGE_VIEW_NAME] (state, { view = '', newView = '' }) {
    const viewName = view.replace(/[^\w]/gi, '')
    const newViewName = newView.replace(/[^\w]/gi, '')
    if (state.views[viewName] && !state.views[newViewName]) {
      Vue.set(state.views, newViewName, Object.assign({}, state.views[viewName]))
      Vue.delete(state.views, viewName)
    }
  },
  [MUTATIONS_METHODS.CLONE_VIEW] (state, { view = '' }) {
    const viewName = view.replace(/[^\w]/gi, '')
    if (state.views[viewName]) {
      let newView = Object.assign({}, state.views[viewName])
      this.commit({
        type: MUTATIONS.CREATE_VIEW,
        view: `${viewName}_${uuidv4()}`,
        metaInfo: newView.metaInfo,
        viewClass: newView.viewClass,
        components: newView.components
      })
    }
  },
  [MUTATIONS_METHODS.ADD_OBJECT] (state, { view = '', object = {} }) {
    const viewName = view.replace(/[^\w]/gi, '')
    if (viewName && state.views[viewName] && object.type) {
      if (Object.keys(object).length === 1) {
        object.plkNoEdited = true
        object.parentClass = 'twelve columns'
      }
      state.views[viewName].components.push(object)
    }
  },
  [MUTATIONS_METHODS.UPDATE_OBJECT] (state, { view = '', position, object }) {
    const viewName = view.replace(/[^\w]/gi, '')
    if (viewName && state.views[viewName]) {
      Vue.set(state.views[viewName].components, position, object)
    }
  },
  [MUTATIONS_METHODS.MOVE_OBJECT] (state, { view = '', lastPosition, newPosition }) {
    const viewName = view.replace(/[^\w]/gi, '')
    if (viewName && state.views[viewName] && lastPosition >= 0 && lastPosition < state.views[viewName].components.length && newPosition >= 0 && newPosition < state.views[viewName].components.length) {
      let components = Object.assign([], state.views[viewName].components)
      components.splice(newPosition, 0, components.splice(lastPosition, 1)[0])
      Vue.set(state.views[viewName], 'components', components)
    }
  },
  [MUTATIONS_METHODS.DELETE_OBJECT] (state, { view = '', position }) {
    const viewName = view.replace(/[^\w]/gi, '')
    if (viewName && state.views[viewName] && position >= 0 && position < state.views[viewName].components.length) {
      Vue.delete(state.views[viewName].components, position)
    }
  }
}

export const MUTATIONS = addNamespaceInOperations('design', MUTATIONS_METHODS)
